module.exports = __webpack_public_path__ + "static/index/assets/img/2.b0c6d8ec.png";